import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Select } from "~/components/select";
import { SelectContent } from "~/components/select/content";
import { SelectItem } from "~/components/select/item";
import { SelectTrigger } from "~/components/select/trigger";
import { SelectValue } from "~/components/select/value";
import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";

import type { FormState } from "./form-state";

export interface WidgetCalculationProps {
	name: string;
	calculation: FormState;
}

export const WidgetCalculation: React.FC<WidgetCalculationProps> = ({ name, calculation }) => {
	const monitor = useMonitor();

	return (
		<Select name={name} onValueChange={(input) => calculation.setInput(input)} value={calculation.getInput(monitor)}>
			<SelectTrigger>
				<SelectValue />
			</SelectTrigger>

			<SelectContent>
				{ALL_CALCULATIONS.map((value) => (
					<SelectItem key={value} value={value}>
						{value}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
